import {
  AgxBodyText,
  AgxColumn,
  AgxDivider,
  AgxHeader,
  AgxRow,
  UpcomingSettlementRow,
  UpcomingSettlementRowLoader,
  UpcomingSettlementTotalRow,
} from '@urbanx/agx-ui-components';
import './UpcomingSettlements.scss';
import { AgxExpandableContent } from '@urbanx/agx-ui-components';
import { PartnershipInformation, UpcomingSettlement } from '@urbanx/agx.rex.client';
import { dateOnlyToDate } from '@urbanx/agx.ui-components2';

const toUpcomingSettlementRow = (settlement: UpcomingSettlement) => ({
  ...settlement,
  settlementDate: dateOnlyToDate(settlement.settlementDate),
});

interface UpcomingSettlementProps {
  loading: boolean;
  partnershipInfo?: PartnershipInformation;
}

const UpcomingSettlements = ({ loading, partnershipInfo }: UpcomingSettlementProps) => {
  const {
    upcomingSettlementsBeforeAnniversary = [],
    upcomingSettlementsOnOrAfterAnniversary = [],
  } = partnershipInfo || {};

  const upcomingSettlementsBeforeAnniversaryRows =
    upcomingSettlementsBeforeAnniversary.map(toUpcomingSettlementRow);

  const upcomingSettlementsOnOrAfterAnniversaryRows =
    upcomingSettlementsOnOrAfterAnniversary.map(toUpcomingSettlementRow);

  return (
    <>
      <AgxColumn extraClasses="upcomingSettlementsBody">
        <AgxRow fill spaceBetween>
          <AgxHeader size={5}>Upcoming Settlements</AgxHeader>
        </AgxRow>
        {upcomingSettlementsBeforeAnniversary.length === 0 && (
          <div>
            <AgxColumn extraClasses="upcomingSettlements noContent">
              <AgxColumn fill centered extraLargeGap extraClasses="noDataDiv">
                <AgxBodyText centered small>
                  No upcoming settlements
                </AgxBodyText>
              </AgxColumn>
            </AgxColumn>
            {upcomingSettlementsOnOrAfterAnniversary.length > 0 && (
              <AgxExpandableContent
                isExpanded={false}
                key={'UpcomingSettlementsExpandableContent'}
                title={'Show settlements past Anniversary date'}
                children={
                  <AgxColumn extraClasses="upcomingSettlements beforeAnniversaryTable">
                    {!loading &&
                      upcomingSettlementsOnOrAfterAnniversaryRows?.map(
                        (settlement, idx: number) => (
                          <UpcomingSettlementRow key={idx} settlements={settlement} />
                        )
                      )}
                  </AgxColumn>
                }
              ></AgxExpandableContent>
            )}
            {upcomingSettlementsOnOrAfterAnniversary.length === 0 && (
              <div>
                <AgxExpandableContent
                  isExpanded={false}
                  key={'NoUpcomingSettlementsExpandableContent'}
                  title={'Show settlements past Anniversary date'}
                  children={
                    <AgxColumn extraClasses="upcomingSettlements noContent">
                      <AgxColumn fill centered extraLargeGap extraClasses="noDataDiv">
                        <AgxBodyText centered>No upcoming future settlements</AgxBodyText>
                      </AgxColumn>
                    </AgxColumn>
                  }
                ></AgxExpandableContent>
              </div>
            )}
          </div>
        )}
        {upcomingSettlementsBeforeAnniversary.length > 0 && (
          <div className="upcomingSettlementsHeader">
            <AgxColumn extraClasses="upcomingSettlements">
              <div className="upcomingSettlementRow header">
                <AgxColumn extraClasses="upcomingSettlement" centerJustified>
                  <AgxBodyText small>Property</AgxBodyText>
                </AgxColumn>
                <AgxColumn extraClasses="upcomingSettlement settlement" centerJustified>
                  <AgxBodyText small>Settlement</AgxBodyText>
                </AgxColumn>
                <AgxColumn extraClasses="upcomingSettlement commission" centerJustified>
                  <AgxBodyText small>Commission</AgxBodyText>
                </AgxColumn>
              </div>
              {loading &&
                [...Array(10)].map((i, idx) => (
                  <>
                    <UpcomingSettlementRowLoader key={idx} />
                    {idx < 10 && <AgxDivider />}
                  </>
                ))}
              {!loading &&
                upcomingSettlementsBeforeAnniversary &&
                upcomingSettlementsBeforeAnniversary.length > 0 &&
                upcomingSettlementsBeforeAnniversaryRows?.map((settlement, idx: number) => (
                  <UpcomingSettlementRow key={idx} settlements={settlement} />
                ))}
              {!loading && upcomingSettlementsBeforeAnniversary.length > 0 && (
                <UpcomingSettlementTotalRow
                  settlements={upcomingSettlementsBeforeAnniversaryRows}
                />
              )}
            </AgxColumn>
            {upcomingSettlementsOnOrAfterAnniversary.length === 0 && (
              <div>
                <AgxExpandableContent
                  isExpanded={false}
                  key={'NoUpcomingSettlementsExpandableContent'}
                  title={'Show settlements past Anniversary date'}
                  children={
                    <AgxColumn extraClasses="upcomingSettlements noContent">
                      <AgxColumn fill centered extraLargeGap extraClasses="noDataDiv">
                        <AgxBodyText centered>No upcoming future settlements</AgxBodyText>
                      </AgxColumn>
                    </AgxColumn>
                  }
                ></AgxExpandableContent>
              </div>
            )}
            {upcomingSettlementsOnOrAfterAnniversary.length > 0 && (
              <AgxExpandableContent
                isExpanded={false}
                key={'UpcomingSettlementsExpandableContent'}
                title={'Show settlements past Anniversary date'}
                children={
                  <AgxColumn extraClasses="upcomingSettlements beforeAnniversaryTable">
                    {!loading &&
                      upcomingSettlementsOnOrAfterAnniversaryRows?.map(
                        (settlement, idx: number) => (
                          <UpcomingSettlementRow key={idx} settlements={settlement} />
                        )
                      )}
                  </AgxColumn>
                }
              ></AgxExpandableContent>
            )}
          </div>
        )}
      </AgxColumn>
    </>
  );
};

export default UpcomingSettlements;
